/* eslint-disable import/no-extraneous-dependencies */
import { useSharableState, useState, view } from '@esui/core';
import { DemoPage, Section } from '../@demo/utils.js';
import { Autocomplete, Item } from '../autocomplete/index.js';
import { DotMenu } from '../dot-menu/index.js';
import '../theme.js';
import { Button } from './index.js';

const countries: Item[] = [
  {
    name: 'Allemagne',
    id: 'GER',
  },
  {
    name: 'France',
    id: 'FRA',
  },
  {
    name: 'Burkina Faso',
    id: 'BFA',
  },
  {
    name: 'Congo',
    id: 'COG',
  },
  {
    name: 'Etats-Unies',
    id: 'USA',
  },
];

export const [ButtonDemo] = view('button-demo', {
  template() {
    const [data, setData] = useState(countries);
    const selected = useSharableState<Item | undefined>(countries[2]);

    function search(text: string) {
      setData(
        countries.filter(
          c =>
            c.id!.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
            c.name.toLocaleLowerCase().includes(text.toLocaleLowerCase())
        )
      );
    }

    return DemoPage(
      Section(
        '',

        DotMenu(
          {
            name: 'name1',
            value: 'value1',
          },
          {
            name: 'name2',
            value: 'value2',
          }
        ).onSelected(item => console.log(item)),

        Autocomplete('Search countries')
          .data(data)
          .onSearch(search)
          .selected(selected)
      ),

      Section('Standard', Button('Standard'), Button('Standard').icon('code')),

      Section(
        'Outlined',
        Button('Outlined').outlined(),
        Button('Outlined').outlined().icon('code')
      ),

      Section(
        'Raised',
        Button('Raised').raised(),
        Button('Raised').raised().icon('code')
      ),

      Section(
        'Unelevated',
        Button('Unelevated').unelevated(),
        Button('Unelevated').unelevated().icon('code')
      ),

      Section(
        'Dense',
        Button('Dense').unelevated().dense(),
        Button('Dense').unelevated().dense().icon('code')
      ),

      Section(
        'Trailing icon',
        Button('Trailing icon').icon('code').trailingIcon(),
        Button('Trailing icon').icon('code').outlined().trailingIcon(),
        Button('Trailing icon').icon('code').raised().trailingIcon(),
        Button('Trailing icon').icon('code').unelevated().trailingIcon()
      ),

      Section(
        'Disabled',
        Button('Disabled').icon('code').disabled(),
        Button('Disabled').icon('code').outlined().disabled(),
        Button('Disabled').icon('code').raised().disabled(),
        Button('Disabled').icon('code').unelevated().disabled()
      ),

      Section(
        'Styling Colors',
        Button('Standard').icon('code'),
        Button('Outlined').icon('code').outlined(),
        Button('Raised').icon('code').raised(),
        Button('Raised disabled').icon('code').raised().disabled(),
        Button('Unelevated').icon('code').unelevated(),
        Button('Unelevated Disabled').icon('code').unelevated().disabled()
      )
        .theme({
          primaryColor: 'darkgreen',
          onPrimaryColor: 'aqua',
        })
        .style('--mdc-button-disabled-fill-color', 'darkseagreen')
        .style('--mdc-button-disabled-ink-color', 'aliceblue'),

      Section(
        'Styling typography',
        Button('lowercase').icon('code'),
        Button('lowercase').outlined().icon('code'),
        Button('lowercase').raised().icon('code'),
        Button('lowercase').unelevated().icon('code')
      )
        .style('--mdc-typography-button-text-transform', 'lowercase')
        .style('--mdc-typography-button-letter-spacing', '4px'),

      Section(
        'Styling padding',
        Button('padding').icon('code'),
        Button('padding').outlined().icon('code'),
        Button('padding').raised().icon('code'),
        Button('padding').unelevated().icon('code')
      ).style('--mdc-button-horizontal-padding', '50px')
    );
  },
});
